<template>
  <div class="carousel-nav">
    <button
      type="button"
      :class="{
        'carousel__prev--in-active': currentSlide <= minSlide,
      }"
      class="carousel__prev"
      aria-label="Previous slide"
      @click.stop="nav.prev"
    >
      <template v-if="hasPrevSlot">
        <slot name="prev" />
      </template>
      <template v-else>
        <img width='40' height='40' :src="`${$assetsCdn}/icons/arrow-left.svg`" alt="Carousel" />
      </template>
    </button>
    <button
      type="button"
      :class="{
        'carousel__prev--in-active': currentSlide >= maxSlide,
      }"
      class="carousel__next"
      aria-label="Next slide"
      @click.stop="nav.next"
    >
      <template v-if="hasPrevSlot">
        <slot name="next" />
      </template>
      <template v-else>
        <img width='40' height='40' :src="`${$assetsCdn}/icons/arrow-right.svg`" alt="Carousel" />
      </template>
    </button>
  </div>
</template>
<script>
import { inject, ref, reactive, computed } from 'vue'
// import Icon from './Icon';
import { defaultConfigs } from './defaults'

export default {
  setup(props, { slots }) {
    const config = inject('config', reactive({ ...defaultConfigs }))
    const maxSlide = inject('maxSlide', ref(1))
    const minSlide = inject('minSlide', ref(1))
    const currentSlide = inject('currentSlide', ref(1))
    const nav = inject('nav', {})

    const hasPrevSlot = computed(() => !!slots.prev)
    const hasNextSlot = computed(() => !!slots.next)

    return {
      config,
      currentSlide,
      minSlide,
      nav,
      hasPrevSlot,
      hasNextSlot,
      maxSlide,
    }
  },
}
</script>
<style lang="scss" scoped>
.carousel__prev,
.carousel__next {
  background-color: var(--vc-nav-background-color);
  border-radius: var(--vc-nav-width);
  width: var(--vc-nav-width);
  height: var(--vc-nav-width);
  text-align: center;
  font-size: calc(var(--vc-nav-width) * 2 / 3);
  padding: 0;
  color: var(--vc-nav-color);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  border: 0;
  cursor: pointer;
}

.carousel__prev {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.carousel__next {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.product-slider {
  @extend %slider
}
</style>
